module.exports = __webpack_public_path__ + "static/best-relationship-total-2022-3e9d04e091bf91885a34a35f3ae18e80.svg";